export const formatDate = (dateString: Date | undefined) => {
    if (dateString) {
      return dateString ? new Date(dateString).toLocaleDateString() : "N/A";
    }
  };